export const OTS_STAFF_DASHBOARD_STATUS_FILTERS_KEY = 'ots-staff-dashboard-status-filters';
